import type { FC } from "react";
import React, { useRef } from "react";

import WalletIcon from "assets/icons/filled/wallet.svg?react";
import { useUser } from "shared/hooks";
import { formatMoney } from "utils/formatMoney";

import Button from "../../Button";
import styles from "../Header.module.scss";

interface WalletBalanceProps {
	onToggleBalance: (wrapper: React.RefObject<null | HTMLDivElement>) => void;
}

const WalletBalance: FC<WalletBalanceProps> = ({ onToggleBalance }) => {
	const { getData: getUserData } = useUser();
	const { user, userCurrency } = getUserData();

	const wrapperRef = useRef<null | HTMLDivElement>(null);

	const toggleDropdown = () => {
		onToggleBalance(wrapperRef);
	};

	return (
		<div className="w-[180px] relative cursor-pointer [&_.input]:cursor-pointer" ref={wrapperRef}>
			<Button
				type="input"
				readonly
				value={formatMoney(user!.balance, { currency: userCurrency })}
				onClick={toggleDropdown}
				endIcon={
					<div className={styles.searchIconWrapper}>
						<WalletIcon />
					</div>
				}
			>
				{formatMoney(user!.balance, { currency: userCurrency })}
			</Button>
		</div>
	);
};

export default WalletBalance;
